module.exports = __webpack_public_path__ + "img/signin-1.b8391c39.png";